import { type BibleViewOptions, type BiblePassageContent } from '@soulhx/fs-common';
import React from 'react';
import { AllCaps } from './AllCaps.js';
import { clsx } from '@soulhx/ui-common';
import { generateItemMap } from './component-helpers.js';

interface BibleContentItem {
  item: BiblePassageContent;
  filterStyle?: string;
  options: BibleViewOptions;
}
export const BibleContentItem = ({ item, filterStyle, options }: BibleContentItem) => {
  if (item.attrs?.style && item.attrs.style.length > 0 && item.attrs.style === filterStyle) return null;

  if (item.type === 'text') {
    return item.text;
  }

  if (item.type === 'tag' && item.name === 'para') {
    return (
      <p className={item.attrs?.style ? item.attrs.style : ''}>
        {item.items && item.items.map(generateItemMap(options, filterStyle))}
      </p>
    );
  }

  if (item.type === 'tag' && item.name === 'char' && item.attrs?.style && item.attrs.style === 'nd' && item.items) {
    return <AllCaps items={item.items} />;
  }

  return (
    <span
      className={clsx(
        {
          'me-1': item.name === 'chapter' || item.name === 'fnID',
          wj: options.redLetters && item.attrs?.style === 'wj',
        },
        item.attrs?.style !== 'wj' && item.attrs?.style
      )}
    >
      {item.items && item.items.map(generateItemMap(options, filterStyle))}
    </span>
  );
};
